import EditWebhookModal from './edit_webhook_modal.js';
import NewWebhookModal from './create_webhook_modal.js';
import { newConfirm } from 'trunks/vue/admin/components/libs/confirm.js';

export default Vue.extend({
  template: `
    <div class="setting-wrapper">
      <button class="mb-6" @click="openNewWebhookModal">新建</button>
      <div class="table-responsive webhook-table">
        <table class="table table-noborder table-striped">
          <thead>
            <tr>
              <th>Payload URL</th>
              <th>Events</th>
              <th>操作</th>
            </tr>
          </thead>
          <tbody>
            <tr class="table-row" v-for="webhook in webhooks" :key="webhook.id">
              <td>
                <div class="row-cell text-ellipsis">{{webhook.payload_url}}</div>
              </td>
              <td class="row-cell">
                <div class="text-ellipsis mr-2" v-for="(event, index) in webhook.subscribed_events" :key="index">
                  {{ event }}
                </div>
              </td>
              <td class="row-cell operation-cell-box">
                <span class="btn-text primary-text mr-4" @click="openEditWebhookModal(webhook)">编辑</span>
                <span class="btn-text error-text" @click="confirmDeleteWebhook(webhook)">删除</span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  `,

  props: {
    webhookable: {
      type: Object,
      required: true,
    },
    allEvents: {
      type: Array,
      default() {
        return [];
      },
    },
    webhookablePath: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      webhooks: [],
      webhookableId: this.webhookable.id,
    };
  },

  created() {
    this.requestwebhooks();
  },

  methods: {
    requestwebhooks() {
      Skylark.Libs.Ajax.get(`/admin/${this.webhookablePath}/${this.webhookableId}/webhooks`, {
        responseType: 'json',
        success: (data) => {
          this.webhooks = data;
        },
      });
    },

    openNewWebhookModal() {
      new NewWebhookModal({
        el: Skylark.Helpers.Utilities.getOrCreateCleaningElementByIdForVue('create_webhook_modal_container'),
        propsData: {
          webhookablePath: this.webhookablePath,
          webhookableId: this.webhookableId,
          allEvents: this.allEvents,
        },
      }).$on('createdSuccessed', (webhook) => {
        this.webhooks.unshift(webhook);
      });
    },

    openEditWebhookModal(webhook) {
      new EditWebhookModal({
        el: Skylark.Helpers.Utilities.getOrCreateCleaningElementByIdForVue('edit_webhook_modal_container'),
        propsData: {
          webhookablePath: this.webhookablePath,
          webhookableId: this.webhookableId,
          webhook,
          allEvents: this.allEvents,
        },
      }).$on('editSuccessed', (updatedWebhook) => {
        const webhookIndex = _.findIndex(this.webhooks, (item) => item.id === updatedWebhook.id);
        this.webhooks.splice(webhookIndex, 1, updatedWebhook);
      });
    },

    confirmDeleteWebhook(webhook) {
      newConfirm({
        title: '删除',
        message: '您确定要删除此条数据吗？',
        icon: "<i class='slp-warning-circle'></i>",
        type: 'danger',
        confirmButtonText: '删除',
        cancelButtonText: '取消',
      }).$on('ensureClicked', () => {
        this.deleteWebhook(webhook);
      });
    },

    deleteWebhook(webhook) {
      Skylark.Libs.Ajax.delete(`/admin/${this.webhookablePath}/${this.webhookableId}/webhooks/${webhook.id}`, {
        contentType: 'application/json; charset=utf-8',
        responseType: 'json',
        success: () => {
          Skylark.Bridge.newAlertify('删除成功', {
            type: 'success',
          });
          this.webhooks = _.without(this.webhooks, webhook);
        },
        error: () => {
          Skylark.Bridge.newAlertify('删除失败', {
            type: 'error',
          });
        },
      });
    },
  },
});
